import { Button } from "PFComponents/button";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./action_buttons.module.scss";

type ActionButtonsProps = {
  onAddButtonClick: VoidFunction;
  onImportButtonClick: VoidFunction;
};

export const ActionButtons = ({ onAddButtonClick, onImportButtonClick }: ActionButtonsProps): JSX.Element => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "header" });

  return (
    <div className={css.actionButtons}>
      <Button
        icon="import"
        text={t("buttons.import")}
        kind="tertiary"
        onClick={onImportButtonClick}
        className={css.button}
      />
      <Button
        icon="add"
        text={t("buttons.add")}
        kind="tertiary"
        onClick={onAddButtonClick}
        className={css.button}
      />
    </div>
  );
};
